// Mutation hook - przypisanie oferty do transakcji
// POST /api/ui/sales-crm/deals/{dealId}/offers/{offerId}

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface IPostDealOfferAssignResponse {
  data?: { success: boolean; dealId: number; offerId: number };
  message?: string;
}

interface IPostDealOfferAssignVariables {
  dealId: number;
  offerId: number;
}

const postDealOfferAssign = ({
  dealId,
  offerId,
}: IPostDealOfferAssignVariables): Promise<IPostDealOfferAssignResponse> =>
  axios.post(`/sales-crm/deals/${dealId}/offers/${offerId}`);

export const usePostDealOfferAssign = (
  options?: UseMutationOptions<IPostDealOfferAssignResponse, IError, IPostDealOfferAssignVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostDealOfferAssignResponse, IError, IPostDealOfferAssignVariables>(
    postDealOfferAssign,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(['sales-crm-deal', variables.dealId]);
        await queryClient.invalidateQueries(['sales-crm-deal-offers', variables.dealId]);
        await queryClient.refetchQueries(['sales-crm-deal-offers', variables.dealId]);
        await queryClient.invalidateQueries(['sales-crm-trader-client-offers-simple']);
        options?.onSuccess?.(data, variables, context);
      },
    },
  );
};
